module.exports = __webpack_public_path__ + "static/demo-23a8f94783dd45385cf5d1aff6bbf0f6.gif";